import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import moment from 'moment'
import BodyText from 'LuxKit/Typography/BodyText'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'

interface Props {
  bookByDate: string
  travelByDate: string
}

export function BnblPackageDates(props: Props) {
  const intl = useIntl()
  const { bookByDate, travelByDate } = props

  return (
    <Group direction="vertical" gap={8} tabletGap={16}>
      <BodyText variant="medium">{intl.formatMessage({
        id: 'ZITkL5Ek84',
        defaultMessage: 'Our offers are live for a limited time. Secure your dream escape at a great price! No dates yet? Reserve the price now and pick dates later.',
        description: 'Introductory text explaining BNBL buy-now-book-later offer dates',
      })}
      </BodyText>

      <Group gap={0} direction="vertical">
        <Heading variant="heading5" style={{ marginBottom: 8 }}>{intl.formatMessage({
          id: '7uh7X2lA30',
          defaultMessage: 'How it works',
          description: 'Heading for the how-it-works steps in BNBL package dates',
        })}
        </Heading>
        <BodyText variant="medium">
          <FormattedMessage
            id="6ls1ZZqe6E"
            defaultMessage="<bold>1. Secure your escape today</bold> to lock in the price."
            description="Step 1 of BNBL how-it-works: secure the escape on the offer detail page"
            values={{
              bold: (chunks) => <strong>{chunks}</strong>,
            }}
          />
        </BodyText>
        <BodyText variant="medium">
          <FormattedMessage
            id="jfDdKxFSZk"
            defaultMessage="<bold>2. Choose dates</bold> anytime before <bold>{bookByDate}</bold> in your account."
            description="Step 2 of BNBL how-it-works: choose dates before deadline"
            values={{
              bold: (chunks) => <strong>{chunks}</strong>,
              bookByDate: moment(bookByDate).format(DMY_CASUAL_FORMAT),
            }}
          />
        </BodyText>
        <BodyText variant="medium">
          <FormattedMessage
            id="A5Bb4KTs1x"
            defaultMessage="<bold>3. Manage your booking online</bold> and travel by <bold>{travelByDate}</bold>."
            description="Step 3 of BNBL how-it-works: manage booking and travel by deadline"
            values={{
              bold: (chunks) => <strong>{chunks}</strong>,
              travelByDate: moment(travelByDate).format(DMY_CASUAL_FORMAT),
            }}
          />
        </BodyText>
      </Group>

      <Group direction="vertical">
        <MessageBanner kind="informational-primary" density="compact">
          <Group direction="horizontal" gap={8} verticalAlign="center">
            <LineInfoCircleIcon />
            <BodyText variant="medium">
              {intl.formatMessage({
                id: '6RDq/efErJ',
                defaultMessage: 'Subject to availability and surcharges (peak period or property-specific). Any surcharges will be shown before confirming your dates.',
                description: 'Disclaimer about availability and surcharges for BNBL package dates',
              })}
            </BodyText>
          </Group>
        </MessageBanner>
      </Group>
    </Group>
  )
}
